import React, { useId } from 'react'

import Typography from "@mui/material/Typography";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { ExpandMore as ExpandMoreIcon } from '@vedmarket/ui-kit';
import { CheckCircleOutline as CheckCircleOutlineIcon } from '@vedmarket/ui-kit';
import { CheckCircle as CheckCircleIcon } from '@vedmarket/ui-kit';

import COLORS from 'styles/colors.scss'
import cx from "classnames";

import './template.scss'

export const renderSummaryCalculatorInfo = (info: SummaryCalculatorInfoRow[], background: string) => (
  info.map((infoDataItem, i) => (
    <ul className='right-panel-item__details' key={i}>
      {infoDataItem.map((item, index) => (
        <li className='right-panel-item__details-item' key={index}>
          <Typography
            variant='caption'
            className='right-panel-item__label'
            sx={{
              background: background,
              position: 'relative',
              whiteSpace: 'pre-line',
              'paddingRight': '4px',
            }}
          >
            {item.label}
          </Typography>
          <Typography
            component='div'
            variant='body2'
            sx={{
              "color": COLORS.BLACK,
              "background": background,
              "position": 'relative',
              "maxWidth": '50%',
              textAlign: 'right',
              flexShrink: 0,
              'paddingLeft': '4px',
              "fontSize": '12px'
            }}
            className='right-panel-item__value'
          >
            {item.value}
          </Typography>
        </li>
      ))}
    </ul>
  ))
)

const Template = (props: SummaryCalculatorTemplateProps) => {

  const accordionId = useId()
  const hideStatusIcons = props.hideStatusIcons
  const canShowProgressIcon = !props.isDisabled || props.inProgress
  const isIncomplete = canShowProgressIcon && !props.isCompleted
  const shouldShowProgressIcon = isIncomplete && !hideStatusIcons
  const shouldShowCompletedIcon = props.isCompleted && !hideStatusIcons

  const infoData = props.info;

  return (
    <div className={cx('right-panel-item', {
      'right-panel-item_isCompleted': props.isCompleted,
      'right-panel-item_noLimeColor': props.noLimeColor,
    })}>
      <Accordion
        sx={{
          boxShadow: 0,
          marginBottom: 0,
          backgroundColor: props.isCompleted && !props.noLimeColor ? COLORS.LIME : COLORS.WHITE,
          '&.Mui-expanded': {
            '&:last-of-type': {
              marginBottom: '0'
            }
          }
        }}
        expanded={props.isExpanded}
        disabled={props.isDisabled}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`${accordionId}-content`}
          id={`${accordionId}-header`}
          onClick={props.onClick}
          sx={{
            '.MuiAccordionSummary-content, .Mui-expanded.MuiAccordionSummary-content': {
              margin: '16px 0'
            },
            '&.Mui-expanded': {
              borderBottom: 'none',
            },
            '.MuiAccordionSummary-expandIconWrapper': {
              svg: {
                width: '32px',
                height: '32px',
              }
            }
          }}
        >
          <Typography variant='subtitle1' className={cx('right-panel-item__text', {
            'right-panel-item__text_noData': props.isDisabled && !props.isCompleted,
          })}>
            {shouldShowCompletedIcon && <CheckCircleIcon style={{
              color: COLORS.GREEN,
              marginRight: '12px',
              width: '24px',
              height: '24px',
            }} />}
            {shouldShowProgressIcon && <CheckCircleOutlineIcon style={{
              color: COLORS.SLIGHTLY_GRAY,
              marginRight: '12px',
              width: '24px',
              height: '24px',
            }} />}
            {props.text}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{
          padding: '0 16px'
        }}>
          {(props.isCompleted || props.shouldShowInfo) && infoData.some((rows) => rows.length) ?
            renderSummaryCalculatorInfo(infoData, props.isCompleted && !props.noLimeColor ? COLORS.LIME : COLORS.WHITE) : null}
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default Template
